import PropTypes from 'prop-types';

import { useIntl } from 'react-intl';

import { get } from 'utils/lodash';

import Grid from '@material-ui/core/Grid';

import { Select, TextLabel } from 'components/common';

import { MENU_ITEMS } from 'settings/constants/menu';

const ResetUsingForm = ({ method, handleChange }) => {
  const { formatMessage } = useIntl();

  const RESET_TYPE = get(MENU_ITEMS, 'selfUnlock.types', []);

  return (
    <Grid container spacing={1} alignItems="center" className="form-spacing">
      <Grid item xs={12} sm={5}>
        <TextLabel label={formatMessage({ id: 'selfUnlock.modal.container.resetUsing' })} />
      </Grid>
      <Grid item xs={12} sm={7}>
        <Select id="reset_using" fullWidth options={RESET_TYPE} value={method} onChange={e => handleChange('method', e.target.value)} />
      </Grid>
    </Grid>
  );
};

ResetUsingForm.propTypes = {
  method: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default ResetUsingForm;
